/**
 * @voltxampere/ui — BPW34 photodiode variant (Sprint 43-6)
 *
 * Silicon PIN photodiode for visible + near-IR (430-1100 nm). Used
 * reverse-biased; photocurrent proportional to illuminance. Default
 * `voltage` 0.6 V, `saturationCurrent` slightly elevated to reflect
 * dark current under reverse bias. Real photoresponse modelling
 * (lambda-dependent quantum efficiency) lands Sprint 47+ along with
 * the broader sensor full-simulation push.
 *
 * Reference: Vishay BPW34. Engine zero-diff invariant honored —
 * canonical `diode` engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { diode } from "../diode.js";
export const sensorBpw34 = {
    id: "bpw34",
    nameTr: "BPW34 (Si PIN Fotodiyot, görünür+NIR, placeholder)",
    nameEn: "BPW34 (Si PIN Photodiode, visible+NIR, placeholder)",
    shortcut: "D",
    category: "active",
    viewBox: diode.viewBox,
    terminals: diode.terminals,
    defaultLabel: "D",
    defaultValue: "BPW34",
    schemaType: "diode",
    defaultParams: { saturationCurrent: 1e-12, idealityFactor: 1.0 },
    renderSVG: () => diode.renderSVG(),
};
//# sourceMappingURL=sensor-bpw34.js.map